import { configureStore } from '@reduxjs/toolkit';
import observacoesReducer from '@store/slices/observacoesSlice';
import documentosReducer from '@store/slices/documentosSlice';
import amostrasReducer from '@store/slices/amostrasSlice';
import relatoriosReducer from '@store/slices/relatoriosSlice';
import planosAcaoReducer from '@store/slices/planosAcaoSlice';
import solicitacoesReducer from '@store/slices/solicitacaoSlice';
import solicitacaoHistoricoReducer  from '@store/slices/solicitacaoHistoricoSlice';
import formularioRespostaItemProcessoReducer from '@store/slices/formularios/ItemProcesso/formularioRespostaItemProcessoSlice';
import formularioRespostaProcessoReducer from '@store/slices/formularios/Processo/formularioRespostaProcessoSlice';
import formularioAssociadoItemProcessoReducer from '@store/slices/formularios/ItemProcesso/formularioAssociadoItemProcessoSlice';
import formularioAssociadoProcessoReducer from "@store/slices/formularios/Processo/formularioAssociadoProcessoSlice";

export const store = configureStore({
  reducer: {
    observacoes: observacoesReducer,
    documentos: documentosReducer,
    amostras: amostrasReducer,
    relatorios: relatoriosReducer,
    planosAcao: planosAcaoReducer,
    solicitacoes: solicitacoesReducer,
    solicitacaoHistorico: solicitacaoHistoricoReducer,
    formularioRespostaItemProcesso: formularioRespostaItemProcessoReducer,
    formularioRespostaProcesso: formularioRespostaProcessoReducer,
    formularioAssociadoItemProcesso: formularioAssociadoItemProcessoReducer,
    formularioAssociadoProcesso: formularioAssociadoProcessoReducer
  },
});
